<template>
    <b-overlay :show="showoverlay" rounded="sm">
        
        <div class="card mt-5 border-0 bg-wash no-shadow">
            <div class="">
                <div v-if="custom_list.length>0">
                    <common-list  :pageurl="this.$api_url"  :is_action="is_action" :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="custom_list" :default_column="default_column" :primary_key="primary_key" v-on:childToParent="listReturn"></common-list>
                </div>
                <div v-else>
                    <div v-if="show_loader" class="list-no-data">
                        <span class="d-block text-center">Looking for relevant data..</span>
                        <!-- <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/> --> <!-- Mustafijur: 24-06-2026: commented -->
                    </div>
                    <div v-else class="list-no-data">
                        Looks like there is no employee profile to show.
                    </div>
                </div>
            </div>
        </div>

    </b-overlay>
</template>


<script>
    export default{
        props: ['pageurl'],        
        
        data(){
            return {
                
                cu:window.location.href,
                ce:false,
                loan_type_vals:[
                    { value: "1", text: "Loan" },
                    { value: "2", text: "Advance" },

                ],
                showoverlaymodal : false,
                employees : [],                
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},
                search_group:{name:'', email:'', phone:'' },
                search_by_id:{department_id:0, jobposition_id:0 , branch_id:0 , status:0},
                loan_type:1,
                modal_title: '',
                company_id_title : '',
                amount_title: '',
                deduction_start_month_title:'',
                effective_date_title :'',
                status_title : '',
                details_title: '',
                loan_type_title: 'Process Type',
                loan_type:1, 
                tenure_title:'',
                count:0,
                fdata : {company_loan_id:'' , employee_id:'', loan_amount:'', loan_type:'', effective_date_of_loan:null , deduction_start_month:null , core_hr:'' , loan_tenure:'',details:'',status:null,core_hr:null},

                selected: [],
                showoverlay : true,
                show_loader: true,
                viewmode :true,

                notice: "Looks like you have not added any employee yet.",
                blankmsg : 'Fetching data..',
                pgurl:this.$api_url,
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},

                /**Child Component property data */
                is_action:0, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
                list_key:0, /* Component Key */
                custom_list:[],  /* Data List */
                default_column:['name','email','jobposition','department'], /* Default Column List */
                appended_column:[],                   /* Appended Column List  and there title and type */
                primary_key:'employee_id',  /* Primary is the unique key of the list this key will be returned if the row is clicked, 
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
                company_options:[],         /* Company Filterable options */

                tmp_custom_list:[],

                custom_array:[],

                /***Child Component property data */
            }
        },
        methods:{
            showLoanDetails: function(x)
            {  
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                let currentObj = this;
                let formData = new FormData();
                formData.append('employee_id', x);
                axios.post(this.$api_url+'/pf/loan/setemployee', formData)
                    .then(function (response) 
                    {    
                        this.showoverlay = false;
                        window.location.href = this.$api_url+'/pf/loan/profile';
                        
                    }.bind(this))
                    .catch(function (error) 
                    { 
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });

            },   
            updateTransactions(x)
            {
                if(!this.checkNet()) return false;
                let currentObj = this; 
                
                axios.get(this.$api_url+'/pf/loan/updatetransactions', {
                    params: {
                        loan_type: 1
                    }
                }).then(function(response){
                    this.$bvModal.hide('bv-modal-loan');
                }.bind(this)).catch(function (error){currentObj.serverError(error);});
                
            },
            getAcl: function()
            {
                axios.get(this.$api_url+'/acl' , {
                    params: {
                        url: this.cu
                    }
                }).then(function(response){
                    this.ce = response.data;                    
                }.bind(this));
            },            
            
            getEmployees: function()
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                this.show_loader = true;
                
                let currentObj = this;

                axios.get(this.$api_url+'/pf/employee/with-loan' , {
                    }).then(function(response){
                        
                        this.showoverlay = false;
                        this.custom_list = response.data.employee_data;
                        this.company_options = response.data.options;
                        this.show_loader = false;

                        }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);});
            },
            listReturn:function(data)
            {
                if(data.employee_id && data.action_id==0)
                {
                    this.showLoanDetails(data.employee_id);
                }
            },

            validateState:function(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },  
        
        },
        
        created: function(){
            $(window).on('load', function (e) {
                setTimeout(function(){
                    $('.div1').width($('table.employee-list-table').width());
                    $('.div2').width($('table.employee-list-table').width());
                    if($('table.employee-list-table').width() > $('.wrapper1').width()){
                        //alert($('table.employee-list-table').width());
                        $('.wrapper1').show();
                    }else{
                        //alert('Its not bigger');
                        $('.wrapper1').hide();
                    }
                }, 2000);
                $('.wrapper1').on('scroll', function (e) {
                    $('.wrapper2').scrollLeft($('.wrapper1').scrollLeft());
                }); 
                $('.wrapper2').on('scroll', function (e) {
                    $('.wrapper1').scrollLeft($('.wrapper2').scrollLeft());
                });
                
                //$('.trz-custom-dropdown .custom-switch input').click(function(){
                $(document).on("click",".trz-custom-dropdown .custom-switch input",function() {
                    setTimeout(function(){
                        $('.div1').width($('table.employee-list-table').width());
                        $('.div2').width($('table.employee-list-table').width());
                        if($('table.employee-list-table').width() > $('.wrapper1').width()){
                            $('.wrapper1').show();
                        }else{
                            $('.wrapper1').hide();
                        }
                    }, 500);
                });
            });
            
            if(this.$cookies.isKey("column_selected"))
            {
                 // if(this.$cookies.get("column_selected") != null) // Rejwan: 03-06-2025 Pf Loan
                if(Array.isArray(this.$cookies.get("column_selected")) && this.$cookies.get("column_selected").length > 0){ // Rejwan: 03-06-2025 Pf Loan
                    // this.column_selected = this.$cookies.get("column_selected").split(',');
                    var cookieVal = this.$cookies.get("report_column_selected");                
                    if (cookieVal != null) {                   
                        if (Array.isArray(cookieVal)) {                        
                            this.column_selected = cookieVal;                    
                        } else {                        
                            this.column_selected = String(cookieVal).split(',');                    
                        }                
                    }
                }
            }

            this.getAcl();            
            this.getEmployees();
            //this.updateTransactions(1);
        }
    }
</script>
<style>
button.disabled{
    cursor: default;
}

</style>